import { Grid } from '@mui/material'
import React, { useState } from 'react'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import HelpNavigation from './HelpNavigation'
import { useAppSelector } from '../../../redux/hooks'
import { PrimaryText } from '../../ui/Text'
import { BLACK } from '../../ui/Colors'
import Avatar from '../Avatar'
import { UsersStatus } from '../../../redux/user/userTypes'
import { ActionMenu } from '../../ui/ActionMenu'


const UserNavigation = () => {
    const [open, setOpen] = useState<boolean>(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const { firstname, lastname, brand, status } = useAppSelector(
        (state) => state.user.user
    )

    const handleClick = (e: React.MouseEvent) => {
        if (open) {
            setAnchorEl(null)
            setOpen(false)
        } else {
            setAnchorEl(e.currentTarget)
            setOpen(true)
        }
    }

    return (
        <Grid
            container
            alignItems="center"
            onClick={(e) => {
                handleClick(e)
            }}
            sx={{ cursor: 'pointer' }}
        >
            <Grid item flex={2}>
                <Avatar name={firstname} />
            </Grid>
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                flex={6}
            >
                <Grid item>
                    <PrimaryText
                        bold
                        color={BLACK}
                    >{`${firstname} ${lastname.toUpperCase()}`}</PrimaryText>
                </Grid>
                {status != UsersStatus.STANDALONE && (
                    <Grid item>
                        <PrimaryText color={BLACK}>{brand}</PrimaryText>
                    </Grid>
                )}
            </Grid>
            <Grid item flex={1}>
                <ArrowRightIcon />
            </Grid>
            <ActionMenu
                open={open}
                anchorEl={anchorEl}
                onClose={(e) => {
                    handleClick(e)
                }}
                children={<HelpNavigation />}
            />
        </Grid>
    )
}

export default UserNavigation
